import type {
  DefaultTheme,
  FlattenInterpolation,
  FlattenSimpleInterpolation,
  ThemeProps,
} from 'styled-components/macro';
import styled, { css } from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

type AvatarSizeStyledT = {
  size?: 'sm' | 'md' | 'lg';
};

type AvatarImageStyledT = {
  imageUrl?: string;
};

const avatarSm = css`
  width: 24px;
  height: 24px;
`;

const avatarMd = css`
  width: 32px;
  height: 32px;
`;

const avatarLg = css`
  width: 200px;
  height: 200px;
`;

const placeholderSm = css`
  font-size: ${({ theme }): string => theme.fontSize.xxs};
`;

const placeholderLg = css`
  font-size: 4rem;
`;

const avatarSize = {
  sm: avatarSm,
  md: avatarMd,
  lg: avatarLg,
};

const placeholderSize = {
  sm: placeholderSm,
  md: placeholderSm,
  lg: placeholderLg,
};

export const AvatarWrapStyled = styled(FlexContainer)<AvatarSizeStyledT>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }): string => theme.radius.half};
  background-color: ${({ theme }): string => theme.colors.primary.variant3};

  ${({ size = 'sm' }): FlattenSimpleInterpolation => avatarSize[size]}
`;

export const AvatarPlaceholderStyled = styled.div<AvatarSizeStyledT>`
  color: ${({ theme }): string => theme.colors.primary.variant1};

  ${({ size = 'sm' }): FlattenInterpolation<ThemeProps<DefaultTheme>> => placeholderSize[size]}
`;

export const AvatarIconStyled = styled.div<AvatarImageStyledT>`
  width: 100%;
  height: 100%;
  background: ${(props): string => `url('${props.imageUrl}') no-repeat center/cover`};
  border-radius: ${({ theme }): string => theme.radius.half};
`;
